/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\BrandSVG\BMW.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Friday March 10th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Friday March 10th 2023 5:02:00 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import { SVGProps } from 'Content/SVG/SVGProps';

function BMW(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M260.79,561.19c0-154.22,125.01-279.22,279.23-279.23,154.21,0,279.21,125.01,279.22,279.23,0,154.21-125.01,279.21-279.22,279.22-154.22,0-279.23-125.01-279.23-279.22h0Zm92.93-186.3c-47.69,47.7-77.16,113.52-77.16,186.3,0,72.78,29.47,138.59,77.16,186.29,47.7,47.68,113.52,77.16,186.3,77.16,72.77,0,138.58-29.48,186.29-77.16,47.69-47.7,77.16-113.52,77.16-186.29,0-72.78-29.48-138.59-77.16-186.3-47.7-47.69-113.52-77.16-186.29-77.16-72.79,0-138.6,29.47-186.3,77.16h0Z"/>
            <path d="M260.9,561.18h279.25V281.96h-.02c-154.21,0-279.22,125-279.23,279.21h0Z"/>
            <path d="M819.18,561.03h-279.25v279.4h.02c154.21,0,279.22-125.19,279.23-279.4h0Z"/>
            <path d="M863.56,302.97l-62.23,41.17,29.45-57.27c-7.65-9.04-19.24-18.55-19.24-18.55l-56.81,28.52,41.68-61.12c-6.92-5.81-14.93-10.64-22.61-16.47l-58.34,91s11.05,6.5,24.57,18.98l60.38-31.23-31.63,59.43c7.11,7.51,13.45,16.61,20.03,24.74l91.9-56.84s-5.63-8.84-17.16-22.35h0Zm-317.08-62.05l28-61.87,2.53,78.44c11.28,.5,27.91,4.75,27.91,4.75l-5.03-111.1c-21.12-3.07-37.96-3.91-37.96-3.91l-26.98,67.11-26.34-66.57s-17.4,1.7-38.52,4.76l-5.05,111.95s16.67-4.82,27.95-5.32l2.38-79.64,28.07,61.4h23.04Zm-236.98,36.38v-.11c2.77-10.17-.4-21.04-8.21-28.12-11.36-10.36-28.28-10.71-46.34,7.31,0,0-33.29,33.38-55.84,66.06l80.98,73.85,61.03-68.42c13.28-14.67,13.8-35.44,1.65-46.53-9.08-8.27-22.25-9.44-33.28-4.05h0Zm-78.12,39.7c28.69-35.54,40.17-45.25,40.17-45.25,7.52-6.51,13.08-7.08,17.6-2.96,4.52,4.11,3.95,12.11-1.26,17.86l-40.55,44.91-15.96-14.55Zm91.17-2.99l-42.58,47.28-16.01-14.59,42.59-47.28c5.21-5.75,13.02-7.15,17.44-3.12s3.77,11.97-1.43,17.71h0Z"/>
        </svg>
    );
}

export default BMW;
